'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _underscore = require('underscore');

var _colors = require('HubStyleTokens/colors');

var _UIDropdown = require('UIComponents/dropdown/UIDropdown');

var _UIDropdown2 = _interopRequireDefault(_UIDropdown);

var _UITypeahead = require('UIComponents/typeahead/UITypeahead');

var _UITypeahead2 = _interopRequireDefault(_UITypeahead);

var _UILoading = require('UIComponents/loading/UILoading');

var _UILoading2 = _interopRequireDefault(_UILoading);

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _getTimezoneGroups = require('timezone-utils/utils/getTimezoneGroups');

var _getTimezoneGroups2 = _interopRequireDefault(_getTimezoneGroups);

var _getTimezoneOptions3 = require('MeetingsLib/utils/getTimezoneOptions');

var _getTimezoneOptions4 = _interopRequireDefault(_getTimezoneOptions3);

var _color = require('MeetingsBase/utils/color');

var _timezone = require('MeetingsLib/constants/timezone');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimezoneSelect = _react2.default.createClass({
  displayName: 'TimezoneSelect',

  propTypes: {
    userTimezone: _react.PropTypes.string.isRequired,
    setTimezone: _react.PropTypes.func.isRequired,
    branding: _react.PropTypes.instanceOf(_Branding2.default).isRequired,
    activeLocale: _react.PropTypes.string,
    isFetchingPublicGlobalBranding: _react.PropTypes.bool.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      options: null,
      optionsMap: null,
      parsedUserTimezone: null
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    var userTimezone = this.props.userTimezone;

    setTimeout(function () {
      var _getTimezoneOptions = (0, _getTimezoneOptions4.default)(),
          options = _getTimezoneOptions.options,
          optionsMap = _getTimezoneOptions.optionsMap;

      var parsedUserTimezone = _timezone.INVALID_TZ_GUESS;
      try {
        parsedUserTimezone = (0, _getTimezoneGroups2.default)().resolve(userTimezone);
      } catch (error) {
        window.Raven.captureBreadcrumb({
          message: 'Invalid timezone was given by `moment.tz.guess()`',
          data: {
            userTimezone: userTimezone,
            error: error
          }
        });
      }
      _this.setState({ options: options, optionsMap: optionsMap, parsedUserTimezone: parsedUserTimezone });
    }, 0);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var _props = this.props,
        currentActiveLocale = _props.activeLocale,
        currentUserTimezone = _props.userTimezone;
    var nextActiveLocale = nextProps.activeLocale,
        nextUserTimezone = nextProps.userTimezone;


    if (currentActiveLocale !== nextActiveLocale) {
      var _getTimezoneOptions2 = (0, _getTimezoneOptions4.default)(),
          options = _getTimezoneOptions2.options,
          optionsMap = _getTimezoneOptions2.optionsMap;

      this.setState({
        options: options,
        optionsMap: optionsMap
      });
    }

    if (currentUserTimezone !== nextUserTimezone) {
      this.setState({
        parsedUserTimezone: (0, _getTimezoneGroups2.default)().resolve(nextUserTimezone)
      });
    }
  },
  onTimezoneChange: function onTimezoneChange(_ref) {
    var value = _ref.target.value;
    var setTimezone = this.props.setTimezone;

    setTimezone(value);
  },
  getDropdownStyle: function getDropdownStyle() {
    var _props2 = this.props,
        isFetchingPublicGlobalBranding = _props2.isFetchingPublicGlobalBranding,
        primaryColor = _props2.branding.primaryColor;


    var colorToUse = isFetchingPublicGlobalBranding ? _colors.EERIE : (0, _color.getPrimaryColorOrDefault)(primaryColor);

    return {
      color: colorToUse,
      display: 'inline-grid'
    };
  },
  renderDropdownText: function renderDropdownText() {
    var _state = this.state,
        optionsMap = _state.optionsMap,
        parsedUserTimezone = _state.parsedUserTimezone;


    return optionsMap[parsedUserTimezone] || parsedUserTimezone;
  },
  render: function render() {
    var options = this.state.options;


    if (options === null) {
      return _react2.default.createElement(_UILoading2.default, { grow: false, minHeight: 80, className: 'p-top-0' });
    }

    var dropdownProps = (0, _underscore.omit)(this.props, 'userTimezone', 'setTimezone', 'branding', 'isFetchingPublicGlobalBranding', 'activeLocale', 'dispatch');

    return _react2.default.createElement(
      _UIDropdown2.default,
      _extends({
        buttonClassName: 'timezone-select m-bottom-4',
        menuWidth: 275,
        buttonUse: 'link',
        buttonText: this.renderDropdownText(),
        placement: 'bottom',
        style: this.getDropdownStyle()
      }, dropdownProps),
      _react2.default.createElement(_UITypeahead2.default, {
        options: this.state.options,
        onChange: this.onTimezoneChange
      })
    );
  }
});

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    activeLocale: state.activeLocale
  };
})(TimezoneSelect);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/schedule/time/TimezoneSelect.js
// module id = 445
// module chunks = 0